<template>
    <button class="btn tw-relative tw-flex tw-justify-center" @click.prevent="$emit('click')">
        <span v-if="! loading">
            <slot></slot>
        </span>
        <img class="spinner tw-absolute" v-else src="/img/loading.gif" width="35">
    </button>
</template>

<script>
export default {
    props: ['loading'],
}
</script>

<style scoped>
.spinner {
    top: 7px;
    left: 50%;
    transform: translateX(-50%);
}
</style>
